import classNames from 'classnames'
import React, { forwardRef } from 'react'
import QtyNumberInput from '../../../QtyNumberInput'
import { QtyNumberInputProps } from '../../../QtyNumberInput/QtyNumberInput'
import * as css from './SizedQuantity.css'

export interface SizedQuantityProps extends QtyNumberInputProps {}

const SizedQuantity = forwardRef<HTMLInputElement, SizedQuantityProps>(
  ({ ...props }, ref) => {
    return (
      <div className={classNames('flex justify-center', css.sizedQty)}>
        <QtyNumberInput {...props} ref={ref} />
      </div>
    )
  }
)

export default SizedQuantity
